import { upperFirst } from 'es-toolkit';

export const getPlanName = (plan?: string) => {
  return upperFirst((plan ?? 'FREE').toLowerCase());
};
